var _line, _path, _path2, _line2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderScaleSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.68122,
    y1: 2.83889,
    x2: 10.7145,
    y2: 1.27327,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4182 3.13295L1.18084 3.04578L1.37502 2.88381L1.4182 3.13295Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0605 1.46189L11.2547 1.29992L11.0173 1.21274L11.0605 1.46189Z",
    fill: "white",
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.0124512,
    y1: 5.9082,
    x2: 13.0003,
    y2: 5.9082,
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0963 6.02636C4.0963 6.38313 3.80708 6.67235 3.45031 6.67235C3.09354 6.67235 2.80432 6.38313 2.80432 6.02636C2.80432 5.66959 3.09354 5.38037 3.45031 5.38037C3.80708 5.38037 4.0963 5.66959 4.0963 6.02636Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderScaleSelected);
export default __webpack_public_path__ + "static/media/slider-scale-selected.be76b009cece07cd9730730852d64a1b.svg";
export { ForwardRef as ReactComponent };